

/*
 * Copyright (c) 2021 by Leyton Group - All Rights Reserved.
 *  This source code, and resulting software, is the confidential and proprietary information
 *  ("Proprietary Information") and is the intellectual property ("Intellectual Property")
 *  of Leyton Group, Inc. ("The Company"). You shall not disclose such Proprietary Information
 *  and shall use it only in accordance with the terms and conditions of any and all license
 *  agreements you have entered into with The Company.
 */

const state = {
  activateUserLoader: false,
  activateAgenceLoader: false,
  addRoleLoader: false,
  loadingModifyMessagerie: false,
  loadingAddMessagerie: false,
  downloadDocumentLoader: false,
  saveSimulationLoader: false,
  dashboardNotificationLoader: false,
  operationNotificationLoader: false,
  workNotificationLoader: false,
  downloadWorksOrSimulations: false,
  downloadOperations: false,
  loading: false,
  requestsPending: 0,
};

const getters = {
  getActivateUserLoader: (state) => state.activateUserLoader,
  getActivateAgenceLoader: (state) => state.activateAgenceLoader,
  getLoading: (state) => state.loading,
  getLoadingModifyMessagerie: (state) => state.loadingModifyMessagerie,
  getLoadingAddMessagerie: (state) => state.loadingAddMessagerie,
  getDownloadDocumentLoader: (state) => state.downloadDocumentLoader,
  getSaveSimulationLoader: (state) => state.saveSimulationLoader,
  getDashboardNotificationLoader: (state) => state.dashboardNotificationLoader,
  getOperationNotificationLoader: (state) => state.operationNotificationLoader,
  getWorkNotificationLoader: (state) => state.workNotificationLoader,
  getDownloadWorksOrSimulations: (state) => state.downloadWorksOrSimulations,
  getDownloadOperations: (state) => state.downloadOperations,
  getAddRoleLoader: (state) => state.addRoleLoader
};


const actions = {

  showActivateUserLoader({ commit }) {
    commit("showActivateUserLoader");
  },
  hideActivateUserLoader({ commit }) {
    commit("hideActivateUserLoader");
  },
  show({ commit }) {
    commit("show");
  },
  hide({ commit }) {
    commit("hide");
  },
  showDownloadDocumentLoader({commit}){
    commit("showDownloadDocumentLoader")
  },
  hideDownloadDocumentLoader({commit}){
    commit("hideDownloadDocumentLoader")
  },
  showAddRoleLoader({commit}){
    commit("showAddRoleLoader")
  },
  hideAddRoleLoader({commit}){
    commit("hideAddRoleLoader")
  },
  showLoadingMessagerieLoaderAction({commit}){
    commit("showLoadingModifyMessagerieLoader")
  },
  hideLoadingMessagerieLoaderAction({commit}){
    commit("hideLoadingModifyMessagerieLoader")
  },
  showAddMessagerieLoaderAction({commit}){
    commit("showAddMessagerieLoader")
  },
  hideAddMessagerieLoaderAction({commit}){
    commit("hideAddMessagerieLoader")
  },
  showSaveSimulationLoader({commit}){
    commit("showSaveSimulationLoader")
  },
  hideSaveSimulationLoader({commit}){
    commit("hideSaveSimulationLoader")
  },
  showDashboardNotificationLoader({commit}){
    commit("showDashboardNotificationLoader")
  },
  hideDashboardNotificationLoader({commit}){
    commit("hideDashboardNotificationLoader")
  },
  showOperationNotificationLoader({commit}){
    commit("showOperationNotificationLoader")
  },
  hideOperationNotificationLoader({commit}){
    commit("hideOperationNotificationLoader")
  },
  showWorkNotificationLoader({commit}){
    commit("showWorkNotificationLoader")
  },
  hideWorkNotificationLoader({commit}){
    commit("hideWorkNotificationLoader")
  }
};

const mutations = {

  showActivateUserLoader(state) {
    state.activateUserLoader = true;
  },
  hideActivateUserLoader(state) {
    state.activateUserLoader = false;
  },
  showDownloadDocumentLoader(state) {
    state.downloadDocumentLoader = true;
  },
  hideDownloadDocumentLoader(state) {
    state.downloadDocumentLoader = false;
  },
  showAddRoleLoader(state) {
      state.addRoleLoader = true;
    },
  hideAddRoleLoader(state) {
      state.addRoleLoader = false;
    },

  showLoadingModifyMessagerieLoader(state) {
    state.loadingModifyMessagerie = true;
  },
  hideLoadingModifyMessagerieLoader(state) {
    state.loadingModifyMessagerie = false;
  },
  showAddMessagerieLoader(state) {
    state.loadingAddMessagerie = true;
  },
  hideAddMessagerieLoader(state) {
    state.loadingAddMessagerie = false;
  },
  showSaveSimulationLoader(state) {
    state.saveSimulationLoader = true;
  },
  hideSaveSimulationLoader(state) {
    state.saveSimulationLoader = false;
  },
  showDashboardNotificationLoader(state) {
    state.dashboardNotificationLoader = true;
  },
  hideDashboardNotificationLoader(state) {
    state.dashboardNotificationLoader = false;
  },
  showOperationNotificationLoader(state) {
    state.operationNotificationLoader = true;
  },
  hideOperationNotificationLoader(state) {
    state.operationNotificationLoader = false;
  },
  showWorkNotificationLoader(state) {
    state.workNotificationLoader = true;
  },
  hideWorkNotificationLoader(state) {
    state.workNotificationLoader = false;
  },
  showDownloadWorksOrSimulations(state) {
    state.downloadWorksOrSimulations = true;
  },
  hideDownloadWorksOrSimulations(state) {
    state.downloadWorksOrSimulations = false;
  },
  showDownloadOperations(state) {
    state.downloadOperations = true;
  },
  hideDownloadOperations(state) {
    state.downloadOperations = false;
  },
  show(state) {
    state.loading = true;
  },
  hide(state) {
    state.loading = false;
  },
  pending(state) {
    if (state.requestsPending === 0) {
      this.commit("loader/show");
    }
    state.requestsPending++;
  },
  done(state) {
    if (state.requestsPending >= 1) {
      state.requestsPending--;
    }
    if (state.requestsPending <= 0) {
      this.commit("loader/hide");
    }
  }
};

export const loader = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
